<template>
  <div class="item-image">
    <div v-if="Array.isArray(item.location) && item.location.length > 0" :style="'display:flex;width:100%;justify-content:' + item.flexPosition">
      <carousel :style="getSize" v-if="render" :navText="['précédent', 'suivant']" :autoHeight="true" :nav="item.showNavButtons" :autoplay="item.autoplaySpeed > 0 ? true : false" :autoplayTimeout="item.autoplaySpeed*1000" :loop="item.isLoop" :items="item.visibleImages">
        <img :key="indexImage" v-for="(image, indexImage) in item.location" :src="image.download" >
      </carousel>
    </div>
    <div v-else :style="'display:flex;width:100%;justify-content:' + item.flexPosition">
      <router-link v-if="item.link" :to="item.link" tag="a">
        <img :style="getSize" :src="item.location" :alt="item.alt" />
      </router-link>
      <img v-else :style="getSize" :src="item.location" :alt="item.alt" />
    </div>

    
  </div>
</template>

<script>
import vSelect from "vue-select";
import carousel from 'vue-owl-carousel'
import draggable from "vuedraggable";

export default {
  props: [
    "preview",
    "contenteditable",
    "colIndex",
    "rowIndex",
    "layout",
    "index",
    "item",
  ],
  data() {
    return {
      render: true,
      visibleCarouselImages: 1,
      chips: [],
      switch1: true,
      loopSwitch: true,
      autoplaySpeed: 0,
      navSwitch: true,
      activePopupFiles: false,
      activePopupAddFile: false,
      flexPosition: "center",
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        ghostClass: "ghost",
      };
    },
    getSize() {
      return " width:" + this.item.width + "%;";
    },
  },
  watch:{
    flexPosition: function (newVal, oldVal) {
      this.item.flexPosition=newVal
      this.flexPosition=newVal
    }
  },    
  created(){
    if(!this.item.flexPosition){
      this.item.flexPosition="center"
    }
  },
  methods: {
    show() {
      this.rerender()
    },
    addImgSrc(data) {
      this.item.location.push({download: data.download, caption: data.caption})
      this.rerender()
    },
    saveList(e) {
      this.rerender()
    },
    rerender() {
      this.render = false
      setTimeout(() => {
        this.render = true
      }, 10);
    },
    removeItem(item) {
      this.item.location.splice(this.item.location.indexOf(item), 1)
      this.rerender()
    },
    folderSrc(data) {
      this.item.location = data;
      this.item.height = 110;
      this.item.autoplaySpeed = 0;
      this.item.visibleImages = 1;
      this.item.showNavButtons = true;
      this.item.isLoop = true;
    },
    imageSrc(data) {
      this.item.location = data.download;
      this.item.height = 110;
    },
    remove() {
      this.layout[this.rowIndex].col[this.colIndex].content.splice(
        this.index,
        1
      );
    },
    saveNavSwitch(e) {
      this.item.showNavButtons = (e.target.value == 'true');
    },
    saveLoopSwitch(e) {
      this.item.isLoop = (e.target.value == 'true');
    },
    saveVisibleImage(e) {
      this.item.visibleImages = e.target.value
    },
    saveAutoplaySpeed(e) {
      this.item.autoplaySpeed = e.target.value
    },
    saveLocation(e) {
      this.item.location = e.target.value;
    },
    saveAlt(e) {
      this.item.alt = e.target.value;
    },
    saveLink(e) {
      this.item.link = e.target.value;
    },
    saveWidth(e) {
      if (e.target.value > 100) {
        this.item.width = 100;
      }
      this.item.width = e.target.value;
    },
    togglePopupFiles(val = false) {
      this.activePopupFiles = val;
    },
    togglePopupAddFile(val = false) {
      this.activePopupAddFile = val;
    }
  },
  components: {
    "v-select": vSelect,
    carousel,
    draggable
  },
};
</script>

<style scoped>
.preview {
  position: absolute;
  left: 4px;
}

.edit {
  float: right;
  width: 90%;
}

.dropdownMenu {
  padding: 10px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}
</style>
